import React, { Component } from "react";
import { Link } from "react-router-dom";

class Navbar extends Component {
  render() {
    return (
      <nav className="navbar navbar-light bg-light">
        <div className="container">
          <Link to="/" className="navbar-brand">
            Where in the world?
          </Link>

        <div className="ms-auto">
          <button className="btn">
            <i className="fa fa-moon-o me-2" aria-hidden="true"></i>
            <span className="fw-bold">Dark Mode</span>
          </button>
        </div>
        </div>

      </nav>
    );
  }
}

export default Navbar;
